import createPageBackground from './createPageBackground.svg';
import createSpaceBackground from './createSpaceBackground.svg';
import createWhiteboardBackground from './createWhiteboardBackground.svg';
import addProfilePictureBackground from './addProfilePictureBackground.svg';
import changeSiteThemeBackground from './changeSiteThemeBackground.svg';
import explorePremiumBackground from './explorePremiumBackground.svg';
import downloadMobileAppBackground from './downloadMobileAppBackground.svg';
import createPageDarkBackground from './createPageDarkBackground.svg';
import createSpaceDarkBackground from './createSpaceDarkBackground.svg';
import createWhiteboardDarkBackground from './createWhiteboardDarkBackground.svg';
import addProfilePictureDarkBackground from './addProfilePictureDarkBackground.svg';
import changeSiteThemeDarkBackground from './changeSiteThemeDarkBackground.svg';
import explorePremiumDarkBackground from './explorePremiumDarkBackground.svg';
import downloadMobileAppDarkBackground from './downloadMobileAppDarkBackground.svg';

export const cards = {
	createPage: {
		light: createPageBackground,
		dark: createPageDarkBackground,
	},
	createSpace: {
		light: createSpaceBackground,
		dark: createSpaceDarkBackground,
	},
	createWhiteboard: {
		light: createWhiteboardBackground,
		dark: createWhiteboardDarkBackground,
	},
	addProfilePicture: {
		light: addProfilePictureBackground,
		dark: addProfilePictureDarkBackground,
	},
	changeSiteTheme: {
		light: changeSiteThemeBackground,
		dark: changeSiteThemeDarkBackground,
	},
	explorePremium: {
		light: explorePremiumBackground,
		dark: explorePremiumDarkBackground,
	},
	downloadMobileApp: {
		light: downloadMobileAppBackground,
		dark: downloadMobileAppDarkBackground,
	},
} as const;
